// Carousel: wheel-scroll + prev/next buttons + optional auto-advance
document.querySelectorAll("[data-carousel]").forEach((carousel) => {
  carousel.addEventListener("wheel", (event) => {
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      carousel.scrollLeft += event.deltaY;
      event.preventDefault();
    }
  }, { passive: false });
});

document.querySelectorAll("[data-carousel-wrap], .mareclo-carousel-wrap").forEach((wrap) => {
  const car = wrap.querySelector("[data-carousel]");
  if (!car) return;
  const step = () => Math.min(car.clientWidth * 0.85, 520);
  wrap.querySelector("[data-carousel-prev]")?.addEventListener("click", () => car.scrollBy({ left: -step(), behavior: "smooth" }));
  wrap.querySelector("[data-carousel-next]")?.addEventListener("click", () => car.scrollBy({ left: step(), behavior: "smooth" }));
});

// Auto-advance bestseller (desktop only)
document.querySelectorAll("[data-autoscroll]").forEach((car) => {
  if (window.matchMedia("(max-width: 900px)").matches) return;
  let paused = false;
  car.addEventListener("mouseenter", () => (paused = true));
  car.addEventListener("mouseleave", () => (paused = false));
  setInterval(() => {
    if (paused || !car.isConnected) return;
    if (car.scrollLeft + car.clientWidth >= car.scrollWidth - 4) car.scrollTo({ left: 0, behavior: "smooth" });
    else car.scrollBy({ left: 280, behavior: "smooth" });
  }, 3600);
});

// Shop the Look: hotspot ↔ row sync
document.querySelectorAll("[data-look]").forEach((look) => {
  const dots = look.querySelectorAll("[data-look-dot]");
  const rows = look.querySelectorAll("[data-look-row]");
  const activate = (i) => {
    dots.forEach((d) => d.classList.toggle("is-active", d.dataset.lookDot === String(i)));
    rows.forEach((r) => r.classList.toggle("is-active", r.dataset.lookRow === String(i)));
  };
  dots.forEach((d) => {
    d.addEventListener("click", () => activate(d.dataset.lookDot));
    d.addEventListener("mouseenter", () => activate(d.dataset.lookDot));
  });
  rows.forEach((r) => {
    r.addEventListener("click", () => activate(r.dataset.lookRow));
    r.addEventListener("mouseenter", () => activate(r.dataset.lookRow));
  });
});

// Tier selector + tabs (PDP)
document.querySelectorAll("[data-tier-selector]").forEach((group) => {
  group.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-tier]");
    if (!button) return;
    group.querySelectorAll("button").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
  });
});

document.querySelectorAll("[data-tabs]").forEach((tabs) => {
  tabs.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-tab]");
    if (!button) return;
    const key = button.dataset.tab;
    tabs.querySelectorAll("[data-tab]").forEach((item) => item.classList.toggle("is-active", item === button));
    tabs.querySelectorAll("[data-panel]").forEach((panel) => panel.classList.toggle("is-active", panel.dataset.panel === key));
  });
});
